


















import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import Action from './Action';
import ActionButton from '@/components/ActionButton.vue';


@Component({
  name: 'ActionGroup',
  components: {ActionButton},
})
export default class ActionGroup extends Vue {
  @Prop({required: true})
  public value!: Action[];

  get actions() {
    return this.value;
  }
}
